import { createSlice } from "@reduxjs/toolkit";

let currentDate = new Date();
let startDate = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() - 1,
  1
);

const initialInventory = {
  storedIphones: [],
  storedIpods: [],
  storedWatches: [],
  storedIphones2: [],
  storedIpods2: [],
  storedWatches2: [],
  storedIphones3: [],
  storedIpods3: [],
  storedWatches3: [],
  storedReports: [],
  storedCityReports: [],
  storedUdhars: [],
  dateGte: new Date(startDate).toISOString().substring(0, 10),
  dateLte: new Date().toISOString().substring(0, 10),
  isAuth: false,
  token: "",
  level: "",
  manageItems: {},
};

const inventorySlice = createSlice({
  name: "invtry",
  initialState: initialInventory,
  reducers: {
    setStoredIphones(state, action) {
      state.storedIphones = action.payload;
    },
    setStoredIpods(state, action) {
      state.storedIpods = action.payload;
    },
    setStoredWatches(state, action) {
      state.storedWatches = action.payload;
    },
    setStoredIphones2(state, action) {
      state.storedIphones2 = action.payload;
    },
    setStoredIpods2(state, action) {
      state.storedIpods2 = action.payload;
    },
    setStoredWatches2(state, action) {
      state.storedWatches2 = action.payload;
    },
    setStoredIphones3(state, action) {
      state.storedIphones3 = action.payload;
    },
    setStoredIpods3(state, action) {
      state.storedIpods3 = action.payload;
    },
    setStoredWatches3(state, action) {
      state.storedWatches3 = action.payload;
    },
    setStoredReports(state, action) {
      state.storedReports = action.payload;
    },
    setStoredCityReports(state, action) {
      state.storedCityReports = action.payload;
    },
    setStoredHistory(state, action) {
      state.storedHistory = action.payload;
    },
    setStoredHistoryAdj(state, action) {
      state.storedHistoryAdj = action.payload;
    },
    setStoredUdhars(state, action) {
      state.storedUdhars = action.payload;
    },
    setGte(state, action) {
      state.dateGte = action.payload;
    },
    setLte(state, action) {
      state.dateLte = action.payload;
    },
    setManageItems(state, action) {
      state.manageItems = action.payload;
    },
    setAuth(state, action) {
      state.isAuth = true;
      state.token = action.payload.token;
      state.level = action?.payload.level;
    },
    revokeAuth(state, action) {
      state.isAuth = false;
      state.token = "";
      state.level = "";
    },
  },
});

export const invtryActions = inventorySlice.actions;

export default inventorySlice.reducer;
